import Api from "../../../lib/api";

export default class ProgrammeCertificate {
	constructor() {
		this.$root = document.getElementById('programmeCertificate');
		this.$certificateContainer = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			return;
		}

		this.$certificateContainer = this.$root.querySelector('.skillz-certificate_inner');
		this.getCertificate();
	}

	getCertificate() {
		const entryId = craft.page.coursesStatsConfig.entryId;

		if (!entryId) {
			throw new Error('ProgrammeCertificate: Course entryId is not defined');
		}

		const params = {};

		params.entryId = entryId;

		const formValuesJson = costorage.get('h_formValues');

		if (formValuesJson) {
			const formValues = JSON.parse(formValuesJson);
			let name = '';

			if (formValues.name) {
				name += formValues.name;
			}

			if (formValues.lastName && name.length) {
				name += ` ${formValues.lastName}`;
			}

			if (name.length) {
				params.name = name;
			}
		}

		Api.get(`${Api.restSiteUrl}/1.0/certificate/preview`, params)
			.then((data) => {
				if (data && typeof data === 'string') {
					data = data.trim();

					if (data.length) {
						this.$certificateContainer.innerHTML = data;
					}
				}
			});
	}
}